// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('selectProdChoice', {
//         templateUrl: 'views/components/views/selectProdChoice/selectProdChoice.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'selectProdChoiceService', 'searchService', function ($stateParams, utilityService, selectProdChoiceService, searchService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let choiceKeyno = $stateParams.choice_keyno;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;
            
//             vm.model = {
//                 productChoiceSearchButtons: [
//                     { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('prodchoice_search') },
//                     { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadProductTypes() }
//                 ],
//                 setting: {
//                     prodchoice_search: ''
//                 },
//                 itemsListProductTypes: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALL

//             async function loadProductTypes() {
//                 if (utilityService.validateParmsValue(vm.model.setting.prodchoice_search, true) !== true) return;

//                 return vm.model.itemsListProductTypes = await selectProdChoiceService.listProductTypes({
//                     prodchoice_search: vm.model.setting.prodchoice_search,
//                     choice_keyno: choiceKeyno,
//                     argtype: argType,
//                     argvalue: argValue
//                 });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALL

//             // #region MULTI CLEAR FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'prodchoice_search':
//                         vm.model.setting.prodchoice_search = '';

//                         if (vm.model.setting.prodchoice_search === '') loadProductTypes();
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion MULTI CLEAR FUNCTION

//             // #region SUBMIT SEARCH FUNCTION

//             vm.searchItems = function () {
//                 loadProductTypes();
//             }

//             // #endregion SUBMIT SEARCH FUNCTION

//             // #region SAVE & GO BACK FUNCTION

//             vm.preOrderLineEdit = function (item) {
//                 searchService.prodChoiceSelected = {
//                     prod_id: item.item_id,
//                     prod_name: item.item_name,
//                     choice_keyno: choiceKeyno
//                 };
//             }

//             // #endregion SAVE & GO BACK FUNCTION

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'prodchoice_search':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.prodchoice_search) !== true) return;

//                         vm.model.setting.prodchoice_search = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.prodchoice_search, true) !== true) return;

//                         if (vm.model.setting.prodchoice_search === '') loadProductTypes();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadProductTypes();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
